var map = {
	"./Cosmos.png": 1288,
	"./Firewoman.png": 8070,
	"./Homem-Aranha.png": 9090,
	"./Homem-de-Ferro.png": 9496,
	"./Kaya.png": 5713,
	"./Midas.png": 9616,
	"./Mulher-Maravilha.png": 5324,
	"./Nino.png": 1797,
	"./Sony.png": 5656,
	"./Super-Homem.png": 1042,
	"./Trisoma.png": 9325,
	"./Velocitor.png": 6730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5909;